<template>
  <div v-if="visible" :class="bannerClass" role="status">
    <span class="v2-membership-banner__icon">
      <v-icon size="20">{{ icon }}</v-icon>
    </span>
    <div class="v2-membership-banner__content">
      <p class="v2-membership-banner__title">{{ title }}</p>
      <p class="v2-membership-banner__description">{{ description }}</p>
    </div>
    <div class="v2-membership-banner__action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
import { isExpired, resolveStatusLabel, formatDate } from "./homeHelpers";

export default {
  name: "MembershipStatusBanner",
  props: {
    status: { type: String, default: null },
    expirationDateLabel: { type: String, default: null },
  },
  computed: {
    isExpired() {
      return isExpired({ validationStatus: this.status });
    },
    visible() {
      return this.isExpired;
    },
    icon() {
      return "mdi-alert-circle";
    },
    title() {
      return this.status === "INACTIVO" ? "Tu membresía está inactiva" : "Tu membresía ha expirado";
    },
    description() {
      if (this.expirationDateLabel) {
        return `Venció el ${this.expirationDateLabel}. Renueva para reactivar tu acceso a todos los beneficios.`;
      }
      return "Renueva para reactivar tu acceso a todos los beneficios de la cámara.";
    },
    bannerClass() {
      return "v2-membership-banner v2-membership-banner--expired";
    },
  },
};
</script>
